import fetch from '../../utils/fetch';
import { getUserToken } from '../../utils/helpers';
import { API_ROUTES } from '../../utils/constants';


export const updateProfileAPI = (data) => {
  const formData = JSON.stringify(data);
  const accessToken = getUserToken().access_token;
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken}`,
  };
  return fetch({
    method: 'PUT', route: API_ROUTES.UPDATE_PROFILE, requestHeaders: headers, data: formData, basic: false,
  });
};

export const deleteUserAPI = (id) => {
  const accessToken = getUserToken().access_token;
  const headers = {
    'Content-Type': '*/*',
    Authorization: `Bearer ${accessToken}`,
  };
  return fetch({
    method: 'DELETE', route: `${API_ROUTES.USERS}/${id}`, requestHeaders: headers, basic: false,
  });
};

export const getProfileAPI = () => {
  const accessToken = getUserToken().access_token;
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken}`,
  };
  return fetch({
    method: 'GET', route: API_ROUTES.GET_PROFILE, requestHeaders: headers, basic: false,
  });
};

export const getProfileStatusAPI = () => {
  const accessToken = getUserToken().access_token;
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken}`,
  };
  return fetch({
    method: 'GET', route: API_ROUTES.GET_PROFILE_STATUS, requestHeaders: headers, basic: false,
  });
};

export const changePasswordAPI = (data) => {
  const accessToken = getUserToken().access_token;
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken}`,
  };
  const formData = JSON.stringify(data);

  return fetch({
    method: 'PUT', route: API_ROUTES.PASSWORD, requestHeaders: headers, data: formData, basic: false,
  });
};

export const getAllUsersAPI = (params) => {
  const accessToken = getUserToken().access_token;
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken}`,
  };
  return fetch({
    method: 'GET', route: API_ROUTES.USERS, requestHeaders: headers, params, basic: false,
  });
};

export const getAllAdminsAPI = (params) => {
  const accessToken = getUserToken().access_token;
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken}`,
  };
  return fetch({
    method: 'GET', route: API_ROUTES.USERS, requestHeaders: headers, params, basic: false,
  });
};

export const getUserLogsAPI = (params) => {
  const accessToken = getUserToken().access_token;
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken}`,
  };
  const { userId } = params;
  const newParams = { ...params };
  delete newParams.userId;
  return fetch({
    method: 'GET', route: `${API_ROUTES.USERS}/${userId}${API_ROUTES.EVENTS}`, requestHeaders: headers, params: newParams, basic: false,
  });
};

export const getAdminProfileAPI = (params) => {
  const accessToken = getUserToken().access_token;
  const headers = {
    'Content-Type': 'multipart/form-data',
    Authorization: `Bearer ${accessToken}`,
  };
  const { userId } = params;
  const newParams = { ...params };
  delete newParams.userId;
  return fetch({
    method: 'GET', route: `${API_ROUTES.USERS}/${userId}`, requestHeaders: headers, params: newParams, basic: false,
  });
};

export const getClientProfileAPI = (params) => {
  const accessToken = getUserToken().access_token;
  const headers = {
    'Content-Type': 'multipart/form-data',
    Authorization: `Bearer ${accessToken}`,
  };
  const { userId } = params;
  const newParams = { ...params };
  delete newParams.userId;
  return fetch({
    method: 'GET', route: `${API_ROUTES.USERS}/${userId}`, requestHeaders: headers, params: newParams, basic: false,
  });
};

export const patchAdminPrivilegesAPI = (params) => {
  const accessToken = getUserToken().access_token;
  const headers = {
    'Content-Type': 'multipart/form-data',
    Authorization: `Bearer ${accessToken}`,
  };
  return fetch({
    method: 'PATCH', route: `${API_ROUTES.USERS_PRIVILEGES}/${params}`, requestHeaders: headers, basic: false,
  });
};

export const demoteAdminPrivilegesAPI = (params) => {
  const accessToken = getUserToken().access_token;
  const headers = {
    'Content-Type': 'multipart/form-data',
    Authorization: `Bearer ${accessToken}`,
  };
  return fetch({
    method: 'PATCH', route: `${API_ROUTES.USERS_PRIVILEGES_DEMOTE}/${params}`, requestHeaders: headers, basic: false,
  });
};




// WEBPACK FOOTER //
// ./src/reducers/user/api.js